export const ORB_TIP_INTERVAL_MS = 12000;
export const ORB_TIP_FADE_MS = 220;
export const ORB_TIP_TYPING_MS = 900;

export const ORB_TIPS_SIDE = 'side' as const;
export const ORB_TIPS_ABOVE = 'above' as const;
export const ORB_TIPS_BELOW = 'below' as const;
export type OrbTipPlacement = typeof ORB_TIPS_SIDE | typeof ORB_TIPS_ABOVE | typeof ORB_TIPS_BELOW;

export const ORB_DESIGN_SIZE = 150;
export const ORB_SIDE_TIPS_HIDDEN_QUERY = '(max-width: 600px)';
